import consumer from "channels/consumer"

export default function(race_id, callback) {
  consumer.subscriptions.create(
    { channel: "RacePerformancesChannel", id: race_id },
    {
      received(data) {
        if(callback) callback(data)
      }
    }
  )
}